<template>
    <div class="input-component" :class="{ 'not-icon': !wantIcon }">
        <div class="label" v-if="label">
            {{label === '_' ? '\u00A0' : label}}
        </div>
        <div class="skeleton" :class="{'match': valuesMatch, 'no-match': valuesDontMatch}">
            <div class="saturn" :class="{'invalid': invalid}" @click="toggleShowError(null, $event)" @mouseover="toggleShowError(true, $event)" @mouseleave="toggleShowError(false, $event)">
                <div class="saturn-textbox">
                    <!--<input type="text" v-model="vm.saturn" :placeholder="placeholder" :readonly="readonly" :disabled="disabled" />-->

                    <vue-numeric v-model="vm.saturn"
                                 :precision="'precision' in $props ? precision : 2"
                                 :minus="allowNegative"
                                 :placeholder="placeholder"
                                 :readonly="readonly"
                                 :disabled="disabled"
                                 v-on:blur="onBlurHandler"
                                 v-on:input="onInputHandler"
                                 :max="maxValue"
                                 :min="minValue"
                                 :maxLength="maxLength"
                                 :thousandSeparator="thousandSeparator"></vue-numeric>

                    <div class="saturn-textbox-error-message" v-if="errorHover && invalid">
                        <div v-if="hasValidationSlot">
                            <slot name="validation"></slot>
                        </div>
                        <div v-else>
                            Invalid Input
                        </div>
                    </div>

                </div>

                <div v-if="hasSlot('action')" class="action-slot">
                    <slot name="action"></slot>
                </div>
                <div v-else-if="wantIcon || incrementValue" class="saturn-icon">
                    <div v-if="incrementValue" class="saturn-increment">
                        <button class="saturn-increment-up" @click="incrementToValue('up',incrementValue)" tabindex="-1"><i class="fas fa-caret-up"></i></button>
                        <button class="saturn-increment-down" @click="incrementToValue('down',incrementValue)" tabindex="-1"><i class="fas fa-caret-down"></i></button>
                    </div>
                    <i v-else-if="isPercent && wantIcon" class="fas fa-percent"></i>
                    <i v-else-if="wantIcon" class="fas fa-hashtag"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueNumeric from '@/components/private/vue-numeric'

    export default {
        name: "InputNumber",
        props: ['saturn', 'cdk', 'label', 'placeholder', 'invalid', 'readonly', 'disabled', 'precision', 'negative', 'isPercent', 'copy', 'comparer', 'get', 'set', 'showIcon', 'increment', 'max', "min", "thousandSeparator", "maxLength"],
        data() {
            return {
                vm: {
                    saturn: null,
                    cdk: null
                },
                errorHover: false,
                wantIcon: null,
                incrementValue: null,
                maxValue: null,
                minValue: null
            };
        },
        computed: {
            valuesMatch() {
                if (this.comparer)
                    return this.cdkValueExists && this.comparer(this.vm.saturn, this.vm.cdk);
                else
                    return this.cdkValueExists && this.isNull(this.vm.saturn) === this.isNull(this.vm.cdk);
            },
            valuesDontMatch() {
                if (this.comparer)
                    return this.cdkValueExists && !this.comparer(this.vm.saturn, this.vm.cdk);
                else
                    return this.cdkValueExists && this.isNull(this.vm.saturn) !== this.isNull(this.vm.cdk);
            },
            cdkValueExists() {
                return 'cdk' in this.$options.propsData;
            },
            hasValidationSlot() {
                return !!this.$slots['validation']
            },
            allowNegative() {
                return 'negative' in this.$props ? this.negative : true;
            }
        },
        mounted() {
            this.init();
            this.wantIcon = typeof this.showIcon != 'undefined' ? this.showIcon : true;
            this.incrementValue = typeof this.increment != 'undefined' ? parseInt(this.increment) : 0;
            this.maxValue = typeof this.max != 'undefined' ? parseInt(this.max) : 9007199254740991;
            this.minValue = typeof this.min != 'undefined' ? parseInt(this.min) : -9007199254740991;

            this.$watch(() => this.$props, function (newValue) {
                this.init();
            }, { deep: true, immediate: true });

            if (!this.get) {
                this.$watch(() => this.vm.saturn, function (newValue) {
                    this.$emit('update:saturn', this.vm.saturn);
                    this.$emit('change');
                }, { deep: true });
            }
        },
        methods: {
            copyValueFromCDK() {
                if (this.copy)
                    this.vm.saturn = this.copy(this.vm.cdk);
                else
                    this.vm.saturn = this.vm.cdk;

                this.updateSaturnGetterVersion();
            },
            incrementToValue(operation, value) {
                let newValue = null
                if (operation == 'up') {
                    newValue = this.vm.saturn + value
                    if (newValue > this.maxValue) {
                        this.vm.saturn = this.maxValue
                    } else {
                        this.vm.saturn = newValue
                    }
                } else if (operation == 'down') {
                    newValue = this.vm.saturn - value
                    if (newValue < this.minValue) {
                        this.vm.saturn = this.minValue
                    } else {
                        this.vm.saturn = newValue
                    }
                }
            },
            init() {
                this.vm.saturn = this.set ? this.set(this.saturn) : (this.saturn != null && typeof this.saturn != 'undefined' ? parseFloat(this.saturn) : null);
                this.vm.cdk = this.cdk != null && typeof this.cdk != 'undefined' ? parseFloat(this.cdk) : null;
            },
            toggleShowError(override, event) {
                //console.log("asd")
                let isMobile = window.matchMedia('(max-width: 600px)').matches;

                if (event.type === 'click') {
                    this.errorHover = !this.errorHover
                }
                else if (!isMobile) {
                    this.errorHover = override;
                }
            },
            hasSlot(name) {
                return !!this.$slots[name]
            },
            isNull(val) {
                if (val === null) {
                    return 0;
                }
                else {
                    return parseFloat(val);
                }
            },
            onBlurHandler($e) {
                if (!$e.target.value) {
                    this.vm.saturn = null;
                }
                this.updateSaturnGetterVersion();
                this.$emit('blur', $e);
            },
            onInputHandler(e) {
                this.$emit('input', e);
            },
            updateSaturnGetterVersion() {
                if (this.get) {
                    this.$emit('update:saturn', this.get(this.vm.saturn));
                    this.$emit('change');
                }
            }
        },
        components: {
            VueNumeric
        }
    };


</script>



